import HeroSlimWrapper from './hero-slim-wrapper'

export default HeroSlimWrapper
